import { useLayoutEffect, useRef, useState } from "react";
import { APIProvider } from "@vis.gl/react-google-maps";
import { Col, Row } from "react-bootstrap";
import WidgetBlock from "../components/WidgetBlock.jsx";
import TripMap from "../components/trip-planner/TripMap.jsx";
import TripResultItem from "../components/trip-planner/TripResultItem.jsx";

const GOOGLE_MAPS_API_KEY = "AIzaSyDgzWSot4NiqhlW2QyRYi1TtAM97nrrvq0";

export default function TripPlanner() {
  const [directions, setDirections] = useState(null);
  const [selectedRouteIndex, setSelectedRouteIndex] = useState(null);
  const widgetRef = useRef(null);
  const [widgetHeight, setWidgetHeight] = useState();

  useLayoutEffect(() => {
    const resizeObserver = new ResizeObserver(([entry]) => setWidgetHeight(entry.contentRect.height));
    if (widgetRef.current) resizeObserver.observe(widgetRef.current);
    return () => resizeObserver.disconnect();
  }, []);

  return (
    <APIProvider apiKey={GOOGLE_MAPS_API_KEY} libraries={["places"]}>
      <Row className="ictapp__trip_planner">
        <Col lg={5} xl={4}>
          <div ref={widgetRef}>
            <WidgetBlock
              onTripResult={result => {
                setDirections(result);
                setSelectedRouteIndex(null);
              }}
              resultsPath="/plan-your-trip/trip-planner"
            />
          </div>

          <TripResultItem
            directions={directions}
            selectedRouteIndex={selectedRouteIndex}
            onSelectRoute={setSelectedRouteIndex}
          />
        </Col>

        <Col lg={7} xl={8}>
          <div className="h-75 w-100" style={{ minHeight: widgetHeight, maxHeight: "1000px" }}>
            <TripMap
              directions={directions}
              selectedRouteIndex={selectedRouteIndex}
            />
          </div>
        </Col>
      </Row>
    </APIProvider>
  );
}
